module.exports = __webpack_public_path__ + "static/media/gallery11.e167ff91.jpg";